import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#FAFCFD',
    color: 'rgb(33, 37, 41)',
    borderBottom: '1px solid rgb(234, 234, 234)',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    paddingBlock: '1rem',
    gap: '1rem',
  },

  menu: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    gap: 10,
  },

  menuItem: {
    fontWeight: 500,
    fontSize: 17,
    color: theme.palette.primary.main,
  },

  logo: {
    display: 'block',
    height: '56px',
    cursor: 'pointer',

    [theme.breakpoints.up('sm')]: {
      height: '64px',
    },
  },
}));
